{
  "role": {
    "SALES": "مندوب مبيعات",
    "TECHNICIAN": "فني"
  },
  "roleHint": {
    "SALES": "تُستحق على المستندات التي يكون المستخدم مندوب مبيعاتها.",
    "TECHNICIAN": "تُستحق على فواتير أعمال الخدمة التي قادها المستخدم (موزعة بين الفنيين)."
  },
  "basis": {
    "INVOICED": "عند الفوترة",
    "COLLECTED": "عند التحصيل"
  },
  "basisHint": {
    "INVOICED": "تُستحق عند ترحيل الفاتورة، ويستردها الإشعار الدائن أو الإلغاء.",
    "COLLECTED": "تُستحق كلما سدد العميل الفاتورة، ويستردها إلغاء الدفعة أو ارتدادها."
  },
  "amountBase": {
    "NET_SALES": "صافي المبيعات",
    "GROSS_PROFIT": "مجمل الربح"
  },
  "amountBaseHint": {
    "NET_SALES": "نسبة من البيع بعد الخصم وقبل ضريبة القيمة المضافة.",
    "GROSS_PROFIT": "نسبة من البيع بعد طرح تكلفته."
  },
  "tierMode": {
    "WHOLE": "الشهر كله بنسبة الشريحة المحققة",
    "MARGINAL": "كل جزء بنسبة شريحته"
  },
  "tierModeHint": {
    "WHOLE": "متى بلغ الشهر شريحة صُرف كله بنسبتها.",
    "MARGINAL": "يُصرف كل جزء من الشهر بنسبة شريحته، كشرائح الضريبة."
  },
  "productType": {
    "GOODS": "سلع",
    "SERVICE": "خدمات"
  },
  "runStatus": {
    "DRAFT": "مسودة",
    "CALCULATED": "محتسب",
    "APPROVED": "معتمد",
    "REVERSED": "معكوس",
    "CANCELLED": "ملغى"
  },
  "statementStatus": {
    "CALCULATED": "محتسب",
    "APPROVED": "معتمد",
    "PAID": "مصروف",
    "CARRIED": "مرحّل"
  },
  "lineKind": {
    "INVOICE": "فاتورة",
    "DEBIT_NOTE": "إشعار مدين",
    "CREDIT_NOTE": "إشعار دائن",
    "COLLECTION": "تحصيل",
    "REVERSAL": "عكس",
    "ADJUSTMENT": "تسوية"
  },
  "plans": {
    "title": "خطط العمولات",
    "subtitle": "من يستحق العمولة وعلى ماذا وبأي نسب",
    "new": "خطة جديدة",
    "active": "فعّالة",
    "inactive": "متوقفة",
    "tiered_zero": "بلا شرائح",
    "tiered_one": "شريحة واحدة",
    "tiered_two": "شريحتان",
    "tiered_few": "{{n}} شرائح",
    "tiered_many": "{{n}} شريحة",
    "tiered_other": "{{n}} شريحة",
    "fields": {
      "name": "الخطة",
      "role": "المستحق",
      "terms": "الشروط",
      "rate": "النسبة",
      "members": "الأعضاء",
      "status": "الحالة"
    },
    "empty": {
      "title": "لا توجد خطط عمولات بعد",
      "body": "أنشئ خطة ثم أضف مندوبي المبيعات أو الفنيين الذين تشملهم."
    }
  },
  "plan": {
    "title": "خطة العمولة",
    "newTitle": "خطة عمولة جديدة",
    "newSubtitle": "الشروط أولًا؛ ويُضاف الأعضاء بعد الحفظ",
    "readOnly": "يمكنك الاطلاع على هذه الخطة؛ وتعديلها يحتاج إلى صلاحية خطط العمولات.",
    "roleLocked": "لا يمكن تغيير المستحق ما دامت للخطة أعضاء.",
    "rateHint": "تُصرف البنود التي لا تشملها نسبة خاصة بهذه النسبة (وتحل الشرائح محلها).",
    "activeHint": "متوقفة: لا يستحق أعضاؤها شيئًا من الاحتساب التالي؛ وتبقى الأشهر المعتمدة.",
    "tiersHint": "اختياري: إجمالي الشهر يحدد النسبة. تبدأ الشريحة الأولى من 0.",
    "ratesHint": "اختياري: نسبة للسلع أو الخدمات، أو لفئة (وفئاتها الفرعية)، أو لكليهما.",
    "noRates": "لا نسب خاصة: يُصرف كل بند بنسبة الخطة.",
    "anyType": "أي نوع",
    "anyCategory": "أي فئة",
    "categorySearch": "ابحث في الفئات",
    "categoryEmpty": "لم يُعثر على فئة",
    "addTier": "إضافة شريحة",
    "removeTier": "حذف الشريحة",
    "addRate": "إضافة نسبة",
    "removeRate": "حذف النسبة",
    "save": "حفظ الخطة",
    "create": "إنشاء الخطة",
    "saved": "حُفظت الخطة",
    "created": "أُنشئت الخطة",
    "sections": {
      "terms": "الشروط",
      "tiers": "الشرائح الشهرية",
      "rates": "النسب حسب المنتج"
    },
    "tabs": {
      "label": "خطة العمولة",
      "plan": "الخطة",
      "members": "الأعضاء"
    },
    "fields": {
      "nameEn": "الاسم بالإنجليزية",
      "nameAr": "الاسم بالعربية",
      "role": "من يستحق",
      "basis": "متى تُستحق",
      "amountBase": "نسبة من ماذا",
      "rate": "النسبة الافتراضية %",
      "active": "فعّالة",
      "notes": "ملاحظات",
      "tierMode": "طريقة صرف الشرائح",
      "fromAmount": "ابتداءً من شهر قدره",
      "tierRate": "النسبة %",
      "productType": "نوع المنتج",
      "category": "الفئة",
      "sliceRate": "النسبة %"
    }
  },
  "preview": {
    "title": "معاينة",
    "hint": "ما يصرفه شهر وفق الخطة كما هي الآن، على البنود التي لا تشملها نسبة خاصة.",
    "amount": "{{base}} شهر قدره",
    "month": "{{base}} الشهر",
    "rate": "النسبة",
    "pays": "العمولة",
    "sentence": "شهر قدره {{amount}} يصرف",
    "incomplete": "أدخل النسبة والشرائح لرؤية المعاينة."
  },
  "members": {
    "intro": "يستحق الأعضاء وفق الخطة عن أشهر كاملة؛ وخطة واحدة لكل شخص ودور في الوقت نفسه.",
    "add": "إضافة عضو",
    "addTitle": "إضافة عضو",
    "editTitle": "تعديل العضو",
    "dialogBody": "من يستحق وفق هذه الخطة بصفة {{role}}، ومن أي شهر، وهدفه الشهري.",
    "edit": "تعديل",
    "remove": "إزالة",
    "removeTitle": "إزالة {{name}} من الخطة؟",
    "removeBody": "لا يُزال إلا عضو لم يرد في أي بيان عمولة بعد؛ وإلا فحدد آخر شهر له.",
    "removed": "أُزيل العضو",
    "added": "أُضيف العضو",
    "saved": "حُفظ العضو",
    "save": "حفظ العضو",
    "actionsFor": "إجراءات {{name}}",
    "empty": "لا يوجد أعضاء بعد.",
    "open": "مفتوح",
    "chooseMonth": "اختر شهرًا",
    "chooseUser": "اختر شخصًا",
    "monthOf": "شهر {{label}}",
    "yearOf": "سنة {{label}}",
    "targetHint": "يظهر نسبة إنجاز في بيانات العمولة ولا يغير النسبة أبدًا.",
    "fields": {
      "user": "الشخص",
      "months": "الأشهر",
      "from": "من",
      "to": "حتى",
      "target": "الهدف الشهري"
    }
  },
  "runs": {
    "title": "كشوف العمولات",
    "subtitle": "كشف لكل شهر بالترتيب: احتساب ثم اعتماد ثم صرف",
    "new": "كشف عمولات جديد",
    "newTitle": "كشف عمولات جديد",
    "newBody": "يحتسب الكشف عمولة الشهر لكل عضو ولكل من لديه رصيد مرحّل.",
    "create": "إنشاء الكشف",
    "created": "أُنشئ كشف عمولات {{period}}",
    "month": "الشهر",
    "year": "السنة",
    "note": "ملاحظة",
    "fields": {
      "period": "الشهر",
      "status": "الحالة",
      "earners": "المستحقون",
      "earned": "عمولة الشهر",
      "payable": "المستحق للصرف"
    },
    "filters": {
      "status": "الحالة",
      "allStatuses": "كل الحالات",
      "year": "السنة",
      "allYears": "كل السنوات"
    },
    "empty": {
      "title": "لا توجد كشوف عمولات بعد",
      "body": "أنشئ أول كشف عمولات.",
      "filteredTitle": "لا يوجد كشف مطابق للتصفية"
    }
  },
  "run": {
    "title": "كشف العمولات",
    "backToList": "العودة إلى كشوف العمولات",
    "calculated": "احتُسب في {{at}} بواسطة {{name}}",
    "approved": "اعتُمد في {{at}} بواسطة {{name}}",
    "journal": "قيد العمولات",
    "staleTitle": "تغيرت الأرقام عند الاعتماد",
    "staleBody": "أعطت إعادة الاحتساب عند الاعتماد أرقامًا أخرى وحُفظت. راجع بيانات العمولة ثم اعتمد مجددًا.",
    "CANCELLED": "أُلغي في {{date}}",
    "REVERSED": "عُكس في {{date}}: عُكس قيد العمولات",
    "totals": "إجماليات الكشف"
  },
  "totals": {
    "earners": "المستحقون",
    "earned": "عمولة الشهر",
    "payable": "المستحق للصرف",
    "paid": "مصروف · غير مصروف",
    "counts": "{{paid}} · {{unpaid}}",
    "carried": "{{n}} مرحّل إلى الشهر التالي"
  },
  "actions": {
    "calculate": "احتساب",
    "recalculate": "إعادة الاحتساب",
    "approve": "اعتماد",
    "cancel": "إلغاء الكشف",
    "reverse": "عكس"
  },
  "calculate": {
    "running": "جارٍ الاحتساب…",
    "toast": "احتُسبت عمولات {{period}}"
  },
  "approve": {
    "title": "اعتماد عمولات {{period}}؟",
    "body": "الاعتماد يقفل الكشف ويرحّل قيد العمولات؛ وتصبح العمولات الموجبة مستحقة الدفع.",
    "confirm": "اعتماد وترحيل",
    "toast": "اعتُمدت عمولات {{period}}"
  },
  "reverse": {
    "title": "عكس عمولات {{period}}",
    "body": "يُعكس قيد العمولات ويمكن إعداد كشف جديد للشهر. للكشف الأخير فقط ما دام لم يُصرف منه شيء.",
    "reason": "السبب",
    "confirm": "عكس الكشف",
    "toast": "عُكست عمولات {{period}}"
  },
  "cancel": {
    "title": "إلغاء كشف عمولات {{period}}",
    "body": "تُحذف بيانات العمولة والتسويات فيه؛ ويمكن إعداد كشف جديد للشهر.",
    "reason": "السبب",
    "confirm": "إلغاء الكشف",
    "toast": "أُلغي كشف عمولات {{period}}"
  },
  "statements": {
    "title": "بيانات العمولة",
    "carryOnly": "رصيد مرحّل فقط",
    "ofTarget": "من",
    "empty": "لا توجد بيانات عمولة في هذا الكشف.",
    "notCalculated": "لم يُحتسب بعد",
    "notCalculatedBody": "احتسب الكشف لإنشاء بيانات العمولة.",
    "fields": {
      "earner": "المستحق",
      "role": "الدور · الخطة",
      "base": "الأساس",
      "achievement": "الإنجاز",
      "earned": "عمولة الشهر",
      "carriedIn": "الرصيد المرحّل",
      "payable": "المستحق للصرف",
      "status": "الحالة"
    }
  },
  "adjustments": {
    "title": "التسويات",
    "hint": "بنود يدوية تبقى عند إعادة احتساب الكشف",
    "add": "إضافة تسوية",
    "addTitle": "إضافة تسوية",
    "addBody": "مبلغ لمرة واحدة لمستحق ودور، مع السبب؛ وبالسالب للاسترداد.",
    "added": "أُضيفت التسوية",
    "delete": "حذف",
    "deleteTitle": "حذف هذه التسوية؟",
    "deleteBody": "تخرج من الكشف عند الاحتساب التالي.",
    "deleted": "حُذفت التسوية",
    "empty": "لا توجد تسويات.",
    "amountHint": "بإشارة: علامة الطرح تسترد العمولة.",
    "fields": {
      "user": "الشخص",
      "role": "الدور",
      "amount": "المبلغ",
      "reason": "السبب"
    }
  },
  "statement": {
    "title": "بيان العمولة",
    "back": "العودة إلى كشف عمولات {{period}}",
    "period": "الشهر",
    "dates": "الفترة",
    "earner": "المستحق",
    "plan": "الخطة",
    "tierRate": "نسبة شريحة الشهر",
    "target": "الهدف الشهري",
    "lines": "البنود",
    "noLines": "لا بنود هذا الشهر.",
    "totals": "إجماليات البيان",
    "base": "أساس الشهر",
    "earned": "عمولة الشهر",
    "carriedIn": "الرصيد المرحّل",
    "payable": "المستحق للصرف",
    "footer": "المبالغ بالريال العماني (<rial/>).",
    "paidDirect": "صُرف في {{date}}",
    "paidByPayroll": "صُرف ضمن كشف الرواتب {{number}}",
    "heldByPayroll": "محجوز لكشف الرواتب {{number}}",
    "carried": "مرحّل إلى الشهر التالي",
    "unpaid": "لم يُصرف بعد"
  },
  "lines": {
    "document": "المستند",
    "slice": "المنتج",
    "current": "قيمته الآن",
    "countedBefore": "المحتسب سابقًا",
    "base": "التغير",
    "rate": "النسبة",
    "amount": "المبلغ",
    "fixed": "عكس بالمبلغ الذي صُرف به"
  },
  "pay": {
    "action": "صرف",
    "title": "صرف العمولة",
    "body": "صرف عمولة {{name}} المعتمدة من حساب نقدي أو بنكي. يُرحّل قيد الصرف.",
    "amount": "المبلغ:",
    "paidOn": "تاريخ الصرف",
    "account": "صُرفت من",
    "accountHint": "الحساب النقدي أو البنكي الذي تُصرف منه العمولة.",
    "chooseAccount": "اختر حسابًا",
    "loadingAccounts": "جارٍ تحميل الحسابات…",
    "reference": "المرجع",
    "confirm": "تسجيل الصرف",
    "toast": "صُرفت العمولة"
  },
  "mine": {
    "title": "عمولتي",
    "subtitle": "بيانات عمولتك عن الأشهر المعتمدة",
    "back": "العودة إلى عمولتي",
    "fields": {
      "period": "الشهر",
      "role": "الدور · الخطة"
    },
    "empty": {
      "title": "لا عمولات بعد",
      "body": "تظهر بيانات عمولتك هنا متى اعتُمد شهر استحققت فيه."
    }
  },
  "form": {
    "fix": "بعض الحقول تحتاج إلى مراجعة.",
    "notSaved": "لم يُحفظ",
    "conflict": "غيّر شخص آخر هذه الخطة في الأثناء. أعد تحميل الصفحة لرؤية نسخته."
  },
  "validation": {
    "percent": "أدخل نسبة بأربع خانات عشرية على الأكثر",
    "atMost100": "100 على الأكثر",
    "notNegative": "لا يمكن أن يكون سالبًا",
    "typeOrCategory": "اختر نوع منتج أو فئة",
    "firstTier": "تبدأ الشريحة الأولى من 0",
    "tierOrder": "يجب أن تأتي بعد الشريحة السابقة",
    "listedTwice": "مكرر",
    "monthStart": "اختر أول يوم من الشهر",
    "monthEnd": "اختر آخر يوم من الشهر",
    "positive": "يجب أن يكون أكبر من صفر",
    "endBeforeStart": "ينتهي قبل أن يبدأ",
    "notZero": "لا يمكن أن يكون صفرًا"
  },
  "errors": {
    "COMMISSION_PERIOD_TAKEN": "لهذا الشهر كشف عمولات قائم.",
    "COMMISSION_RUN_STATUS": "لا يمكن تنفيذ ذلك في حالة الكشف الحالية. أعد تحميل الصفحة لرؤيتها.",
    "COMMISSION_NOT_CALCULATED": "احتسب الكشف قبل اعتماده.",
    "COMMISSION_STALE": "تغيرت الأرقام بإعادة الاحتساب عند الاعتماد وحُفظت. راجعها ثم اعتمد مجددًا.",
    "COMMISSION_SAME_PERSON": "أنت من احتسب هذا الكشف، فيجب أن يعتمده شخص آخر.",
    "COMMISSION_OUT_OF_ORDER": "تُشغَّل الأشهر بالترتيب: شهر سابق مفتوح أو مفقود، أو شهر لاحق معتمد.",
    "COMMISSION_MEMBER_OVERLAP": "هذا الشخص عضو في خطة بالدور نفسه لجزء من هذه الأشهر.",
    "COMMISSION_MEMBER_IN_USE": "ورد هذا العضو في بيان عمولة: حدد آخر شهر له بدلًا من إزالته.",
    "COMMISSION_PLAN_NAME_TAKEN": "لخطة أخرى هذا الاسم.",
    "COMMISSION_IN_PAYROLL": "بيان العمولة هذا محجوز لكشف رواتب مفتوح: سيُصرف في قسيمة الراتب.",
    "COMMISSION_NOT_REVERSIBLE": "لا يُعكس إلا آخر كشف معتمد، ما دام لم يُصرف منه شيء ولم يُحجز شيء منه لكشف رواتب.",
    "SALESPERSON_INVALID": "اختر مستخدمًا نشطًا.",
    "TREASURY_ACCOUNT_INVALID": "اختر حسابًا نقديًا أو بنكيًا نشطًا للصرف منه."
  }
}
